import { select, put, takeLatest, all } from "redux-saga/effects";
import api from "../../Environment";
import { createNotification } from "react-redux-notify";
import { getErrorNotificationMessage } from "../../components/helper/NotificationMessage";
import {
  fetchCountriesFailure,
  fetchCountriesSuccess,
} from "../../store/actions/CountryAction";
import { FETCH_COUNTRIES_START } from "../../store/actions/ActionConstant";
import { updatePayoutInfo } from "../../store/actions/PayoutAction";
import { showErrorComponent } from "../actions/ComponentAction";

function* fetchCountriesAPI() {
  try {
    const response = yield api.postMethod("countries");
    const profileData = yield select((state) => state.users.profile.data);

    if (response.data.success) {
      yield put(fetchCountriesSuccess(response.data.data));
      const profileCountry = response.data.data.find(
        (c) => c.id === profileData?.country_id
      );
      yield put(
        updatePayoutInfo({
          destinationCountry: profileCountry?.code_3 ?? "USA",
        })
      );
    } else {
      yield put(fetchCountriesFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchCountriesFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

export default function* countrySaga() {
  yield all([yield takeLatest(FETCH_COUNTRIES_START, fetchCountriesAPI)]);
}
